import API from "./api";

export const GetModules = (configUrl: string) =>  API.get(`${configUrl}api/UserAccess/modules`);
